import { styled } from '@mui/material';

export const StyledChunkImageWrap = styled('div')(({ theme }) => ({
	width: '100%',
	height: '100%',
	maxHeight: '400px',
	display: 'flex',
	justifyContent: 'center',

	[theme.breakpoints.down('sm')]: {
		maxHeight: '320px',
	},
}));

export const StyledChunkImage = styled('img')({
	display: 'flex',
	height: '100%',
	maxWidth: '100%',
	objectFit: 'contain',
	objectPosition: 'center',
	borderRadius: '16px',
});
